const getPatientHeightIn = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient.Vitals[0]
    ? (patient.Vitals[0]['Height Ft'] * 12) + patient.Vitals[0]['Height In'] : null;
};

export default getPatientHeightIn;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientHeightIn.js